// extracted by mini-css-extract-plugin
export var quantityInput = "_gm-0";